import { Button, Heading, DrawerHeader } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { Filter } from 'types';
import { Search } from './Search';

export interface IProps {
  filter: Filter;
  onCloseFilterSetup: () => void;
  search: string;
  setSearch: (searchValue: string) => void;
}

export const Header = ({ filter, onCloseFilterSetup, search, setSearch }: IProps) => {
  return (
    <DrawerHeader data-selector={`filter-setup-header-${filter.key}`}>
      <Button
        variant="secondary"
        size="sm"
        mb="3"
        leftIcon={<FontAwesomeIcon className="utility-icon" icon={faArrowLeft} />}
        onClick={onCloseFilterSetup}
      >
        All Filters
      </Button>

      <Heading as="h2" fontSize="2xl" mb="3">
        {filter.name}
      </Heading>

      {filter.showSearch && <Search inputSearch={search} setInputSearch={setSearch} />}
    </DrawerHeader>
  );
};
